import React, {FC, useCallback, useRef, useState} from 'react';

import {Popup} from '@gravity-ui/uikit';
import {UserMenuContent, UserMenuView} from '@yandex-data-ui/common';
import {getAuthHref, isYaTeam} from 'ui/utils/getAuthUrl';

import {basePathWithoutLastSlash, popupPlacement} from './UserDropdown.constants';
import {getRetpathUrl} from './UserDropdown.utils';

const {user, cloud} = window.YC;

const UserDropdown: FC = () => {
    const anchorRef = useRef<HTMLElement>(null);
    const [open, setOpen] = useState(false);
    const uniqId = 'user-dropdown';

    const toggleOpen = useCallback(() => setOpen((state) => !state), []);
    const removeOpen = useCallback(() => setOpen(false), []);

    return (
        <>
            <UserMenuView
                size="l"
                compact={false}
                ref={anchorRef}
                user={user}
                onClick={toggleOpen}
                internal={isYaTeam}
                menuOpen={open}
                menuId={uniqId}
                signInUrl={getAuthHref()}
            />
            <Popup
                anchorRef={anchorRef}
                open={open}
                placement={popupPlacement}
                onClose={removeOpen}
                id={uniqId}
                role="menu"
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
                focusTrap
                restoreFocus
            >
                <UserMenuContent
                    user={user}
                    cloudAuth={cloud}
                    accounts={user?.accounts}
                    internal={isYaTeam}
                    oauthUrl={basePathWithoutLastSlash}
                    baseUrl={basePathWithoutLastSlash}
                    getRetpathUrl={getRetpathUrl}
                />
            </Popup>
        </>
    );
};

export default UserDropdown;
